import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaMicrophone, FaPaperPlane, FaUpload } from "react-icons/fa";
const CustomModalOperator = ({
    show,
    handleClose,
    title,
    description,
    buttons = [],
    count,
    setCount,
    notes,
    setNotes,
    onSend,
}) => {
    const [localCount, setLocalCount] = useState(count);
    const [localNotes, setLocalNotes] = useState(notes);
    const [selectedIssue, setSelectedIssue] = useState("");
    useEffect(() => {
        if (show) {
            setLocalCount(count);
            setLocalNotes(notes);
            setSelectedIssue("");
        }
    }, [show]);
    const handleIncrease = () => {
        const updated = localCount + 1;
        setLocalCount(updated);
    };
    const handleDecrease = () => {
        const updated = localCount > 0 ? localCount - 1 : 0;
        setLocalCount(updated);
    };
    const handleCountChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setLocalCount(Number(value));
        }
    };
    const handleIssueClick = (issue) => {
        setSelectedIssue(issue);
        setLocalNotes((prev) =>
            prev.includes(issue) ? prev : prev ? `${prev}, ${issue}` : issue
        );
    };
    const handleSend = () => {
        const finalNotes = localNotes?.trim();
        if (onSend) {
            onSend({
                count: localCount,
                notes: finalNotes,
            });
        }
        setCount(localCount);
        setNotes(finalNotes);
        handleClose();
        setTimeout(() => {
            setLocalCount(0);
            setLocalNotes("");
            setSelectedIssue("");
        }, 100);
    };
    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family" >
              <Modal.Header closeButton>
              <h2 className="font_family">{title}</h2>
              </Modal.Header>
            <Modal.Body className="">
                <div className="quantity-control d-flex align-items-center justify-content-between border rounded px-2 py-1 mt-3 font_family">
                    <button className="qty-btn" onClick={handleDecrease}>
                        −
                    </button>
                    <input
                        type="text"
                        className="text-center fw-bold"
                        style={{
                            border: "none",
                            boxShadow: "none",
                            outline: "none",
                            backgroundColor: "transparent",
                            width: "50px",
                        }}
                        value={localCount}
                        onChange={handleCountChange}
                    />
                    <button className="qty-btn" onClick={handleIncrease}>
                        +
                    </button>
                </div>
                <div className="border rounded p-3 mb-3 mt-4">
                    <div className="bg-secondary-subtle text-muted p-3 rounded mb-3 w-50">
                        {description}
                    </div>

                    <div className="row g-3 mb-4">
                        {buttons.map((btn, idx) => (
                            <div className="col-md-4 col-sm-4 col-6" key={idx}>
                                <div
                                    className={`bg-white rounded p-3 text-center h-100 border customModalOperator ${selectedIssue === btn
                                        }`}
                                    style={{
                                        cursor: "pointer",
                                        wordWrap: "break-word",   
                                        overflowWrap: "break-word",
                                        whiteSpace: "normal"      
                                    }}
                                    onClick={() => handleIssueClick(btn)}
                                >
                                    <strong>{btn}</strong>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="border rounded p-2">
                        <div className="d-flex align-items-center">
                            <div className="d-flex gap-2">
                                <Button variant="light" className="border">
                                    <FaUpload />
                                </Button>
                                <Button variant="light" className="border">
                                    <FaMicrophone />
                                </Button>
                            </div>
                            <div className="flex-grow-1 mx-2">
                                <textarea
                                    className="form-control border-0 shadow-none"
                                    rows="1"
                                    placeholder="Type here..."
                                    style={{ resize: "none" }}
                                    value={localNotes}
                                    onChange={(e) => setLocalNotes(e.target.value)}
                                />
                            </div>
                            <div>
                                <Button variant="primary" onClick={handleSend}>
                                    <FaPaperPlane />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CustomModalOperator;
